<script setup lang="ts">
    import { toRef } from 'vue'

    import type { AttributeDataReadModel } from '@Alternatives/Alternatives/Domain/readmodels'

    // ---------------- props ----------------

    const props = defineProps<{
        readModel: AttributeDataReadModel
    }>()

    // ---------------- shortcuts ----------------

    const rm = toRef(props, 'readModel')
</script>

<template>
    <div>
        <strong>{{rm.Title}}</strong>
        <div>
            <div v-if="rm.HasValue">
                <div v-if="rm.HasMultipleValues">
                    <ul>
                        <li v-for="v in rm.ValuesAsArray">
                            {{v}}
                        </li>
                    </ul>
                </div>
                <div v-else>
                    <span>{{rm.Value}}</span>
                </div>
            </div>
            <div v-else>
                <span class="text-muted font-italic">Not provided</span>
            </div>
        </div>
        <small class="text-muted">{{rm.Description}}</small>
    </div>
</template>